export const checkActiveBranch = (branches, branch_id) => {
    var active = true;
    branches.map(brnch => {
            if (brnch.id === branch_id && brnch.status === 0) {
                active = false;
            }
        }
    )
    return active;
}